import { Options } from '@angular-slider/ngx-slider';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { UserBreathWorkoutService } from 'src/app/services/user-breath-workout.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-breathe-edit-entry',
  templateUrl: './breathe-edit-entry.component.html',
  styleUrls: ['./breathe-edit-entry.component.scss']
})
export class BreatheEditEntryComponent  implements OnInit {
  isLoading = false;
  bsDate = new Date();
  maxDate = new Date();
  userData:any;
  submitted = false;
  exercises:any;
  durations = [
    '1-5', '10', '15','20','25','30','35','40','45','50','55','60+'
  ];
  intensity: number = 5;
  options: Options = {
    floor: 0,
    ceil: 10,
    hideLimitLabels:true,
    hidePointerLabels:true,
    showTicks:true,
    getTickColor: (value: number): string => {
      if (value ==1) {
        return '#1D8670';
      }
      if (value == 2) {
        return '#608F62';
      }
      if (value == 3) {
        return '#879359';
      }
      if (value == 4) {
        return '#B39950';
      }
      if (value == 5) {
        return '#DB9E47';
      }
      if (value == 6) {
        return '#EF9742';
      }
      if (value == 7) {
        return '#ED853F';
      }
      if (value == 8) {
        return '#EA723D';
      }
      if (value == 9) {
        return '#E8603B';
      }
      if (value == 10) {
        return '#E54B38';
      }
      return '#cccccc';
    }
  };

  breathWorkout:any;
  entryId:any;

  @ViewChild('entryForm', { static: false }) entryForm?: NgForm;
  constructor(
    private userBreathWorkoutService: UserBreathWorkoutService,
    private router: Router,
    private userService:UserService,
    private route:ActivatedRoute
  ) {}

  ngOnInit(): void {

    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
      }
    });


    this.route.params.subscribe((params) => {
      this.entryId = params.id;
      this.isLoading = true;
      forkJoin({
        breathWorkout: this.userBreathWorkoutService.fetch(this.entryId),
      }).subscribe(
        (responseData) => {
          this.isLoading = false;
          this.breathWorkout = responseData.breathWorkout;
          this.bsDate = moment(this.breathWorkout.workout_date).toDate();
          this.intensity = this.breathWorkout.intensity;
        },
        (error) => {
         // this.errors.push(error.message);
        }
      );
    });

  }

  onSubmitForm() {
    this.userBreathWorkoutService
      .update(
        this.entryId,
        moment(this.bsDate).format('YYYY-MM-DD HH:mm:ss'),
        +this.entryForm?.value.breaths,
        +this.entryForm?.value.resistance,
        +this.intensity
      )
      .subscribe((responseData) => {
        window.scroll(0,0);
        this.submitted = true;
        /*
        // refresh it
        Swal.fire({
          icon: 'success',
          title: 'Workout Added',
          text: 'Your workout was added',
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['/activity', 'fit', 'level', this.userData.fit_level]));*/
      });
  }
  getMaxTime(){
    if(moment(this.bsDate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
      return new Date();
    }
    else{
      let maxTime = new Date();
      maxTime.setHours(23);
      maxTime.setMinutes(59);
      return maxTime;
    }
  }


  onDeleteEntry() {
    Swal.fire({
      title: "Are you sure?",
      text:  "You won't be able to undo this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText:'Cancel',
      confirmButtonText:'Yes, delete it',
    }).then((result) => {
      if (result.value) {
        this.userBreathWorkoutService.delete(this.entryId).subscribe(
          (responseData) => {
            Swal.fire("Your entry has been deleted", "success");
            // redirect
            this.router.navigateByUrl('/nothing', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/activity', 'fit', 'all-entries']);
          })


          },
          (error) => {
            this.isLoading = false;
            Swal.fire('Error', 'An unknown error has occured, please contact us', 'error');
          }
        );
      }
    });
  }


}
